<template>
  <a-card>
    <a-row type="flex" justify="space-between">
      <a-col :span="4">
        <a-avatar
          shape="square"
          class="avatar"
          :size="40"
          :src="workInfo.avatar?workInfo.avatar_url:'/img/avatar.png'"
        />
        <span style="margin-left: 20px">{{
          workInfo.realname || workInfo.username
        }}</span>
      </a-col>
      <a-col :span="20">
        <div class="project-meta">
          <h2 class="title">{{ workInfo.workName }}</h2>
          <p class="time">发布于：{{ workInfo.createTime }}</p>
        </div>
      </a-col>
    </a-row>
    <JMavonEditor v-model="workInfo.content" :editable="false" :subfield="false" defaultOpen="preview"/>
    <a-divider></a-divider>
    <div class="project-detail">
      <!-- 作品信息 -->
      <div class="project-info">
        <a-row type="flex">
          <a-col :span="24">
            <div class="project-op">
              <a-icon type="eye" />
              <span class="gap"> {{ workInfo.viewNum }}</span>

              <a-icon type="like" @click="starWork" />
              <span class="gap"> {{ workInfo.starNum }}</span>
              <a-divider type="vertical"></a-divider>
              <span class="gap">分享到</span>
              <a-popover placement="bottom" title="微信扫一扫手机体验和分享">
                <template slot="content">
                  <qrcode :value="getShareUrl()" :size="200" level="H"></qrcode>
                </template>
                <a-icon type="wechat" />
              </a-popover>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <br />
    <a-card :bordered="false">
      <!-- 评论区 -->
      <div class="project-comment">
        <div class="publish">
          <a-row type="flex" justify="space-between">
            <a-col span="3" class="comment-user">
              <a-avatar
                shape="square"
                :size="60"
                icon="user"
                :src="avatarUrl"
              />
              <p>
                {{
                  $store.state.user.info && $store.state.user.info.realname
                    ? $store.state.user.info.realname
                    : "未登录"
                }}
              </p>
            </a-col>
            <a-col :span="16">
              <a-textarea
                v-model="commentContent"
                :rows="5"
                :maxLength="500"
                placeholder="说说这个作品怎么样吧"
              ></a-textarea>
            </a-col>
            <a-col :span="4">
              <div class="comment-btn">
                <a-button :disabled="!token" type="dashed" @click="comment"
                  >发表评论</a-button
                >
              </div>
            </a-col>
          </a-row>
        </div>
        <a-divider />
        <a-list
          class="comment-list"
          item-layout="horizontal"
          :locale="{ emptyText: '暂无评论' }"
          :data-source="comments"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <a-comment
              :author="item.nickname || item.realname || item.username"
            >
              <a-avatar
                shape="square"
                :size="40"
                slot="avatar"
                icon="user"
                :src="item.avatar"
              />
              <p class="comment-content" slot="content">
                {{ item.comment }}
              </p>
              <a-tooltip
                slot="datetime"
                :title="moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')"
              >
                <span>{{ moment(item.createTime).fromNow() }}</span>
              </a-tooltip>
            </a-comment>
          </a-list-item>
          <div
            v-if="showLoadingMore"
            slot="loadMore"
            :style="{
              textAlign: 'center',
              marginTop: '12px',
              height: '32px',
              lineHeight: '32px',
            }"
          >
            <a-spin v-if="loadingMore" />
            <a-button type="link" v-else @click="workComments">
              加载更多
            </a-button>
          </div>
        </a-list>
      </div>
    </a-card>
  </a-card>
</template>

<script>
import Vue from "vue";
import { getAction, postAction } from "@/api/manage";
import { mapGetters } from "vuex";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import QrCode from "@/components/tools/QrCode";
import JMavonEditor from "@/components/jeecg/JMavonEditor"
import moment from "moment";
export default {
  components: {
    qrcode: QrCode,
    JMavonEditor
  },
  data() {
    return {
      workId: "",
      workInfo: {},
      token: "",
      commentContent: "",
      showLoadingMore: true,
      loadingMore: false,
      commentsPage: 0,
      comments: [],
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        mark: true, // 标记
        superscript: true, // 上角标
        quote: true, // 引用
        ol: true, // 有序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        help: true, // 帮助
        code: true, // code
        subfield: true, // 是否需要分栏
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        /* 1.3.5 */
        undo: true, // 上一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
      },
    };
  },
  computed: {
    avatarUrl() {
      if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
        return this.$store.state.user.info.avatar;
      } else {
        return "/img/avatar.png";
      }
    },
  },
  created() {
    this.workId = this.$route.query.workId;
    this.getWorkInfo(this.workId);
    this.token = Vue.ls.get(ACCESS_TOKEN);
  },
  methods: {
    ...mapGetters(["nickname", "avatar", "userInfo"]),
    moment,
    getWorkInfo(workId) {
      getAction("/teaching/teachingWork/studentWorkInfo?workId=" + workId).then(
        (res) => {
          if (res.success) {
            this.workInfo = res.result;
            this.workComments();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    starWork() {
      getAction("/teaching/teachingWork/starWork?workId=" + this.workId).then(
        (res) => {
          if (res.success) {
            if (res.message == "点赞成功") {
              this.workInfo.starNum += 1;
            }
            this.$message.success(res.message);
          }
        }
      );
    },
    workComments() {
      this.commentsPage += 1;
      this.loadingMore = true;
      getAction("/teaching/comment/queryCommentBySourceId", {
        id: this.workId,
        page: this.commentsPage,
      }).then((res) => {
        this.loadingMore = false;
        if (res.result.length == 0 && this.commentsPage > 1) {
          this.$message.info("已加载完啦！");
        } else {
          this.comments = this.comments.concat(res.result);
        }
      });
    },
    comment() {
      if (this.commentContent != "") {
        postAction("/teaching/comment/saveComment", {
          sourceType: '2',
          sourceId: this.cmsInfo.id,
          comment: this.commentContent,
        }).then((res) => {
          if (res.success) {
            this.comments.unshift({
              comment: this.commentContent,
              realname: this.$store.state.user.info.realname,
              avatar: this.avatarUrl,
              createTime: new Date(),
            });
            this.commentContent = "";
            this.$message.success(res.message);
          }
        });
      }
    },
    getShareUrl() {
      return (
        window.location.protocol +
        "//" +
        window.location.host +
        "/work/mdView?workId=" +
        this.workId
      );
    },
  },
};
</script>

<style lang="less" scoped>
.project-detail {
  width: 730px;

  .project-info {
    padding: 10px;
    .project-meta {
      text-align: left;
    }
    .project-op {
      color: #797979;
      .anticon {
        font-size: 28px;
      }
      .gap {
        margin-right: 20px;
        font-size: 24px;
      }
    }
  }
}
.project-comment {
  padding: 10px;
  .publish {
    .comment-user {
      text-align: center;
      padding-top: 20px;
    }
    .comment-btn {
      padding-top: 10px;
      button {
        height: 80px;
      }
    }
  }
  .comment-list {
    color: #999;
    border: 1px solid #e9e9e9;
    border-top: none;
    padding: 0 20px;
    .comment-content {
      width: 600px;
    }
    .item {
      padding: 20px;
      font-size: 13px;
      border-bottom: 1px solid #e9e9e9;

      .people {
        font-size: 30px;
      }
      .user {
        color: #666;
        font-size: 14px;
        margin-right: 5px;
      }
      .time {
        font-size: 12px;
      }
      span {
        margin-right: 30px;
      }
      p {
        margin: 10px 0;
      }
    }
    .more {
      font-size: 13px;
      text-align: center;
      padding-top: 40px;
      padding-bottom: 20px;
      > span {
        border: 1px solid #e9e9e9;
        line-height: 47px;
        width: 140px;
        height: 47px;
        display: inline-block;
        color: #999;
      }
    }
  }
}
</style>